export const visit = (vm, at) => {
vm(require("timezone-utils/lang/nl.lyaml"));
vm(require("ui-addon-i18n/lang/nl.lyaml"));
vm(require("UIComponents/lang/nl.lyaml"));
vm(require("MeetingsLib/lang/nl.lyaml"));
vm(require("sanitize-text/lang/nl.lyaml"));
vm(require("I18n/lang/nl.lyaml"));
at({ "nl": { "placeholderString": "Vergaderingen" } });
};